import { toast } from 'sonner';
import { useState } from 'react';
import UserLayout from 'layouts/UserLayout';
import UserService from 'services/userService';

export default function ProfilePage() {
  const [currentUser] = useState(UserService.getCurrentUser());

  function handleUpdate() {
    toast.error('This feature has been disabled by the admin');
  }

  return (
    <UserLayout currentUser={currentUser}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-4xl p-4 text-white select-none">
        <div className="bg-[#1B1B1B] p-12 rounded-2xl">
          <div className="flex flex-col items-center">
            <img src={'/api/v2/image/resize?image=' + currentUser.image + '&size=large'} alt="Profile" className="w-64 h-64 rounded-full mb-4" />
            <h3 className="text-2xl font-bold p-2">{currentUser.username}</h3>
            {(currentUser.role !== 'user' && <p className="text-gray-200 rounded-full text-xs bg-indigo-400 px-4 py-1">{currentUser.role}</p>) || (
              <p className="text-gray-200 rounded-full text-xs bg-[#292929] px-4 py-1">{currentUser.role}</p>
            )}
          </div>
        </div>

        <div className="bg-[#1B1B1B] p-12 rounded-2xl">
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              placeholder={currentUser.email}
              className="bg-[#292929] appearance-none rounded-lg w-full py-2 px-4"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              placeholder="********"
              className="bg-[#292929] appearance-none rounded-lg w-full py-2 px-4"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block font-bold mb-2" htmlFor="password">
              Image URL
            </label>
            <input id="text" placeholder={currentUser.image} className="bg-[#292929] appearance-none rounded-lg w-full py-2 px-4" disabled />
          </div>
          <div className="flex items-center justify-between mt-8">
            <button
              type="submit"
              className="bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg w-full"
              onClick={handleUpdate}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </UserLayout>
  );
}
